import { ISSUE_API_ROOT } from '../constants';

const STATUS_AUDIT_ACTIVITY_TYPES = ['CREATED', 'STATUS_CHANGED'];
export const ACTIVITY_TAB_FILTERS = {
  STATUS_AUDIT: {
    includeActivityTypes: STATUS_AUDIT_ACTIVITY_TYPES.join(','),
  },
};

export const buildActivityListApiUrl = ({
  baseApiUrl,
  issueId,
  includeActivityTypes,
}) => {
  const apiUrl = new URL(`${baseApiUrl}${ISSUE_API_ROOT}/activity`);
  apiUrl.searchParams.set('issueId', issueId);

  if (includeActivityTypes) {
    apiUrl.searchParams.set('includeActivityTypes', includeActivityTypes);
  }

  return apiUrl.href;
};
